module.exports = __webpack_public_path__ + "static/media/bubble-background.86c6eb54.svg";